import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    Typography,
    useMediaQuery,
    Alert,
    Box,
} from '@mui/material';
import { theme } from '../../../../../shared/theme';
import PaymentHistory from '../../../Bookings/Fees/PaymentHistory';

type Props = {
    reservation: any;
    expanded: boolean;
    onToggle: (event: React.SyntheticEvent, isExpanded: boolean) => void;
};

export default function GuestPaymentHistoryAccordion({
    reservation,
    expanded,
    onToggle,
}: Props) {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const hasGuestPayments =
        Array.isArray(reservation?.guestPaymentHistory) &&
        reservation.guestPaymentHistory.length > 0;

    const outerAccordionSx = {
        mt: 2,
        borderRadius: 2,
        boxShadow: 'none',
        '&::before': { display: 'none' },
        overflow: 'hidden',
    };

    const summarySx = {
        py: 1.25,
        backgroundColor: theme.palette.neutral.main,
    };

    const detailsSx = {
        pb: isMobile ? 2 : 3,
        pt: 0,
        backgroundColor: theme.palette.neutral.main,
    };

    const cardSx = {
        backgroundColor: theme.palette.custom.cardActionBackground,
        borderRadius: 2,
        px: isMobile ? 1.5 : 2,
        py: 1.5,
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={onToggle}
            disableGutters
            square={false}
            sx={outerAccordionSx}
        >
            <AccordionSummary
                aria-controls='guest-payments-content'
                id='guest-payments-header'
                sx={{ ...summarySx, px: 0 }}
            >
                <Typography
                    variant='h2'
                    sx={{
                        letterSpacing: 0.2,
                        color: theme.palette.text.secondary,
                    }}
                >
                    Payments
                </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ ...detailsSx, px: 0 }}>
                <Divider sx={{ mt: 0, mb: 2 }} />

                {hasGuestPayments ? (
                    <Box sx={{ ...cardSx }}>
                        <PaymentHistory reservationDetails={reservation} />
                    </Box>
                ) : (
                    <Alert
                        severity='info'
                        sx={{
                            ...cardSx,
                            mb: 0,
                            fontSize: 13,
                            fontWeight: 800,
                            py: 2,
                            justifyContent: 'center',
                            textAlign: 'center',
                            '& .MuiAlert-icon': { display: 'none' },
                            '& .MuiAlert-message': {
                                width: '100%',
                                textAlign: 'center',
                            },
                        }}
                    >
                        No payment history
                    </Alert>
                )}
            </AccordionDetails>
        </Accordion>
    );
}
